/**
 * Odoo Modules Catalog API client (P3-B Doc 37).
 */
import { api } from "./client";

export type ModuleStatus = "idle" | "activating" | "done" | "error";

export interface OdooModule {
  name: string;
  odoo_state: string;
  odoo_display_name: string;
  odoo_summary?: string | null;
  icon?: string | null;
  label_vi?: string | null;
  main_models: string[];
  is_curated: boolean;
  status: ModuleStatus;
  generated_form_codes: string[];
  generated_workflow_codes: string[];
  last_error?: string | null;
  activated_at?: string | null;
}

export interface ModuleListResponse {
  items: OdooModule[];
}

export interface ActivateRequest {
  models?: string[];
  locale?: "vi" | "en";
}

export interface ActivateResponse {
  module_name: string;
  status: ModuleStatus;
  generated_form_codes: string[];
  skipped_models: string[];
  error?: string | null;
}

export const odooModulesApi = {
  list: (): Promise<ModuleListResponse> =>
    api.get<ModuleListResponse>("/api/v1/admin/odoo-modules"),

  activate: (
    moduleName: string,
    body: ActivateRequest = {},
  ): Promise<ActivateResponse> =>
    api.post<ActivateResponse>(
      `/api/v1/admin/odoo-modules/${moduleName}/activate`,
      body,
    ),

  deactivate: (moduleName: string): Promise<void> =>
    api.delete<void>(`/api/v1/admin/odoo-modules/${moduleName}`),
};
